import {GET, POST} from '../modules/fetch.ts';
import {showFomanticModal} from '../modules/fomantic/modal.ts';
import {addDelegatedEventListener, createElementFromHTML, hideElem, showElem} from '../utils/dom.ts';
import {html} from '../utils/html.ts';

export function initRepositoryCategoryModal() {
  let activeModal: HTMLElement | null = null;
  addDelegatedEventListener(document, 'click', '[data-repository-categories-url]', (button, event: MouseEvent) => {
    event.preventDefault();
    if (activeModal) return;
    const url = new URL(button.getAttribute('data-repository-categories-url')!, window.location.origin);
    url.searchParams.set('modal', 'true');
    const modal = createElementFromHTML<HTMLElement>(html`
      <div class="ui small modal repository-category-modal" aria-labelledby="repository-category-modal-title">
        <div class="header" id="repository-category-modal-title">仓库分类管理</div>
        <div class="scrolling content">
          <div class="ui negative message tw-hidden repository-category-error" role="alert"></div>
          <div class="repository-category-content" aria-live="polite">正在加载分类…</div>
          <button class="ui button tw-hidden repository-category-retry" type="button">重新加载</button>
        </div>
        <div class="actions">
          <a class="ui button" href="${button.getAttribute('data-repository-categories-browse-url')!}">浏览分类仓库</a>
          <button class="ui cancel button" type="button">关闭</button>
        </div>
      </div>
    `);
    activeModal = modal;
    const content = modal.querySelector<HTMLElement>('.repository-category-content')!;
    const error = modal.querySelector<HTMLElement>('.repository-category-error')!;
    const retry = modal.querySelector<HTMLButtonElement>('.repository-category-retry')!;
    let busy = false;
    let closed = false;

    const load = async (form?: HTMLFormElement) => {
      if (busy) return;
      const data = form ? new FormData(form) : undefined;
      if (data?.get('action') === 'delete' && !window.confirm('确定删除这个分类吗？分类内的仓库会保留，并恢复普通列表显示。')) return;
      busy = true;
      hideElem([error, retry]);
      content.setAttribute('aria-busy', 'true');
      const controls = content.querySelectorAll<HTMLInputElement | HTMLButtonElement>('input, button');
      for (const control of controls) control.disabled = true;
      try {
        const response = form ? await POST(url.href, {data}) : await GET(url.href);
        if (!response.ok) {
          const result = response.headers.get('content-type')?.includes('application/json') ? await response.json() : null;
          throw new Error(result?.error || '无法加载或保存分类，请检查登录状态或稍后重试。');
        }
        const manager = createElementFromHTML<HTMLElement>(await response.text());
        if (!manager.matches('.repository-category-manager')) throw new Error('登录状态已失效，请刷新页面后重新登录。');
        if (closed) return;
        content.replaceChildren(manager);
        if (form) document.dispatchEvent(new CustomEvent('ce-repository-categories-updated'));
        if (!form || data?.get('action') === 'save' && !data.get('category_id')) {
          manager.querySelector<HTMLInputElement>('input[name="name"]')!.focus();
        }
      } catch (err) {
        if (closed) return;
        error.textContent = err instanceof Error ? err.message : '网络异常，请重试。';
        showElem(error);
        if (!form) showElem(retry);
      } finally {
        busy = false;
        content.removeAttribute('aria-busy');
        for (const control of controls) control.disabled = false;
      }
    };

    modal.addEventListener('submit', (event) => {
      if (!(event.target instanceof HTMLFormElement)) return;
      event.preventDefault();
      load(event.target);
    });
    retry.addEventListener('click', () => load());
    showFomanticModal(modal, {
      onHidden() {
        closed = true;
        activeModal = null;
        modal.remove();
        button.focus();
      },
    });
    load();
  });
}
